module.exports = __webpack_public_path__ + "static/media/farmerspost.6fb6e0fa.PNG";